module.exports = "/_next/static/images/fo-8f0093440014f1c0721a4108ffdf1a4f.svg";